/* eslint-disable react/jsx-no-useless-fragment */
import React, { Fragment } from 'react';
import styled from 'styled-components';
import {
  CagTypographyVariant, CagTypography, ListItem, CtaModal, List,
  SpacingContainer, sizes, TYPOGRAPHY_COLORS, ResponsiveLayout,
  HorizontalDivider,
} from '@hyphengroup/cag-components';
import { getComponentConfig } from 'helpers/Utils';
import {
  bool, func, shape, string, arrayOf,
} from 'prop-types';
import {
  exitModalSignupLoginBtnClickEvent,
  exitModalLearnMoreClickEvent, exitModalCloseEvent,
} from 'components/tracking/ExitModalTrackingUtils';

const HorizontalDividerContainer = styled.div`
  width: calc(100% + ${sizes(4)});
  margin-left: -${sizes(2)};
`;

const SignupExitModal = ({
  hideSignupExitModal,
  isSignupExitModalOpen,
  showSignup,
  userAgent: { isMobile },
  baseURL,
  componentConfig,
  language,
  track,
}) => {
  const modalData = getComponentConfig({ componentConfig }).SIGNUP_EXIT_MODAL;

  if (!modalData) {
    return null;
  }

  return (
    <CtaModal
      titleColor={TYPOGRAPHY_COLORS.BRAND_01}
      body={(
        <SpacingContainer marginBottom={[sizes(2), sizes(5)]}>
            <SpacingContainer marginBottom={[sizes(2), sizes(3)]}>
              <SpacingContainer marginBottom={sizes(1)}>
                <CagTypography
                  dataSelector="CtaModal-body"
                  color={TYPOGRAPHY_COLORS.BRAND_ACTIVE}
                  variant={{
                    _: CagTypographyVariant.BODY_SML_SEMIBOLD,
                    2: CagTypographyVariant.BODY_BOLD,
                  }}
                >
                  {modalData.MODAL_CONTENT_SUBTITLE?.text}
                </CagTypography>
              </SpacingContainer>
              <CagTypography
                dataSelector="signupExitModal-description"
                variant={{ _: CagTypographyVariant.BODY_SML, 2: CagTypographyVariant.BODY }}
              >
                {modalData.MODAL_CONTENT_DESCRIPTION?.text}
              </CagTypography>
            </SpacingContainer>

            <SpacingContainer marginBottom={[sizes(1), sizes(2)]}>
              <CagTypography
                dataSelector="CtaModal-body"
                color={TYPOGRAPHY_COLORS.BRAND_ACTIVE}
                variant={{
                  _: CagTypographyVariant.BODY_SML_SEMIBOLD,
                  2: CagTypographyVariant.BODY_BOLD,
                }}
              >
                {modalData.MODAL_CONTENT_LIST_HEADER?.text}
              </CagTypography>
            </SpacingContainer>

            <List itemMarginBottom={[sizes(1), sizes(2)]} markerMarginRight={sizes(2)}>
              {modalData.MODAL_CONTENT_LIST?.text.map((text, index) => (
                <ListItem status="exclusive" key={text}>
                  <CagTypography
                    dataSelector={`signupExitModal-listItem-${index}`}
                    variant={{
                      _: CagTypographyVariant.BODY_SML,
                      2: CagTypographyVariant.BODY,
                    }}
                  >
                    {text}
                  </CagTypography>
                </ListItem>
              ))}
            </List>
            <ResponsiveLayout
              renderLargeTablet={() => (
                <HorizontalDividerContainer>
                  <HorizontalDivider variant="ghost" />
                </HorizontalDividerContainer>
              )}
              renderDesktop={() => <Fragment />}
            />
          </SpacingContainer>
      )}
      ctaText={isMobile
        ? modalData.MODAL_CTA_TEXT_MOBILE?.text
        : modalData.MODAL_CTA_TEXT_DESKTOP?.text
        }
      secondaryCtaText={modalData.MODAL_SECONDARY_CTA_TEXT?.text}
      isOpen={isSignupExitModalOpen}
      onCtaClick={() => {
        hideSignupExitModal();
        showSignup();
        exitModalSignupLoginBtnClickEvent(track, language);
      }}
      onSecondaryCtaClick={() => {
        hideSignupExitModal();
        const win = window.open(`${baseURL}${modalData.MODAL_SECONDARY_CTA_LINK?.text}`, '_blank');
        win.focus();
        exitModalLearnMoreClickEvent(track, language);
      }}
      onClose={() => {
        hideSignupExitModal();
        exitModalCloseEvent(track, language);
      }}
      title={modalData.MODAL_TITLE?.text}
      variant="secondary"
    />
  );
};

SignupExitModal.propTypes = {
  hideSignupExitModal: func.isRequired,
  isSignupExitModalOpen: bool.isRequired,
  showSignup: func.isRequired,
  userAgent: shape({
    isMobile: bool,
  }),
  baseURL: string.isRequired,
  componentConfig: arrayOf(shape({})),
  language: string.isRequired,
  track: func.isRequired,
};

export default SignupExitModal;
